import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaUserTie } from "react-icons/fa6";
import JobPosts from "./index";

const jobPostRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Job Posts",
		basePath: "job-posts",
		mainComponent: <JobPosts />,
	    layout: "/console",
		icon: <FaUserTie className="icon-item"/>,
	    subTitle:"Job Post",
		level:5,
		moduleId: 0,
	})
]

export default jobPostRoutes;